import { TokenSymbol } from 'modules/common/types/TokenSymbol';
import { ReactComponent as EthereumIcon } from '../assets/ethereum.svg';

import {
  BlockchainNetworkId,
  getBlockChainExplorerAddress,
} from 'modules/common/conts';
import { t } from 'modules/i18n/utils/intl';

export type ChainType = BlockchainNetworkId.mainnet | BlockchainNetworkId.sepolia;

export const getChainConfig = (tarChain: ChainType) => {
  const chainList: {
    [key in ChainType]: any;
  } = {
    [BlockchainNetworkId.mainnet]: {
      icon: <EthereumIcon />,
      title: t('header.select-chain.eth'),
      subTitle: '',
      chainConfig: {
        chainId: '0x1',
        chainName: 'Ethereum Chain Mainnet',
        nativeCurrency: {
          name: 'Ethereum',
          symbol: TokenSymbol.ETH,
          decimals: 18,
        },
        rpcUrls: [
          'https://mainnet.infura.io/v3/',
        ],
        blockExplorerUrls: [
          getBlockChainExplorerAddress(BlockchainNetworkId.mainnet),
        ],
      },
    },
    [BlockchainNetworkId.sepolia]: {
      icon: <EthereumIcon />,
      title: 'Sepolia',
      subTitle: '',
      chainConfig: {
        chainId: '0xaa36a7',
        chainName: 'Sepolia',
        nativeCurrency: {
          name: 'Ethereum',
          symbol: TokenSymbol.ETH,
          decimals: 18,
        },
        rpcUrls: [
          'https://sepolia.infura.io/v3/',
        ],
        blockExplorerUrls: [
          getBlockChainExplorerAddress(BlockchainNetworkId.sepolia),
        ],
      },
    },
  };

  return chainList[tarChain];
};
